module.exports = __webpack_public_path__ + "static/media/OneAutomotive.94f2e58b.png";